import { render, staticRenderFns } from "./ServicePorts.vue?vue&type=template&id=380d4c7f&scoped=true&"
import script from "./ServicePorts.vue?vue&type=script&lang=js&"
export * from "./ServicePorts.vue?vue&type=script&lang=js&"
import style0 from "./ServicePorts.vue?vue&type=style&index=0&id=380d4c7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380d4c7f",
  null
  
)

export default component.exports